import React, { useState } from "react"
import { useTranslation } from "@/langs/useTranslation";
import {
  Typography,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  Grid,
  Checkbox
} from "@material-ui/core";
import useStyles from "./reduceStyle";

const LoopMode = ({ readonly, handleChange, values }) => {
  const { t } = useTranslation("powerManagement")
  const classes = useStyles();

  return (
    <div className={classes.datePicker} style={{ marginLeft: "0" }}>
      <RadioGroup
        className="loopTypeSelect"
        aria-label="date"
        value={values.loopMode}
        name="contentTemplateDetail.loopMode"
        onChange={handleChange}
      >
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <FormControl>
              <FormControlLabel
                disabled={readonly}
                value="daily"
                style={{ width: "50px", margin: 0 }}
                control={<Radio color="primary" />}
                label={<div>{t("dialog.dailyText")}</div>}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <FormControl>
              <FormControlLabel
                disabled={readonly}
                value="weekly"
                style={{ width: "50px", margin: 0 }}
                control={<Radio color="primary" />}
                label={<div>{t("dialog.weeklyText")}</div>}
              />
            </FormControl>
          </Grid>
        </Grid>
      </RadioGroup>
      <div className="loopType" style={{ borderLeft: "1px solid #aaa" }}>
        {values.loopMode === "daily" ? (
          <RadioGroup
            aria-label="date"
            value={values.loopDailyValue}
            onChange={handleChange}
            name="contentTemplateDetail.loopDailyValue"
            style={{flexDirection: "row"}}
          >

            <FormControl>
              <FormControlLabel
                style={{ margin: 0, marginLeft: 8 }}
                disabled={readonly}
                value="every_day"
                control={<Radio color="primary" />}
                label={
                  <div className="flex_center">
                    <div className="mr-2x">
                      {t("dialog.everyText")}
                    </div>
                    <div className="ml-2x">
                      {t("dialog.daysText")}
                    </div>
                  </div>
                }
              />
            </FormControl>

            <FormControl>
              <FormControlLabel
                style={{ margin: 0 }}
                disabled={readonly}
                value="every_workdays"
                control={<Radio color="primary" />}
                label={<div>{t("dialog.everyWorkDays")}</div>}
              />
            </FormControl>
          </RadioGroup>
        ) : (
          <Grid container spacing={2}>
            {/* <Grid item xs={12} sm={12} md={12} lg={12}>
              <div className="weeklyEvery ml-1">
                <div className="mr-2x">{t("dialog.everyText")}</div>
                <div className="ml-2x">
                  {t("dialog.weeksText")}
                  {weeklyTimes > 4 && (
                    <Typography
                      color="error"
                      component="span"
                      style={{ marginLeft: 8 }}
                    >
                      {t({ defaultMessage: "输入上限：4" })}
                    </Typography>
                  )}
                </div>
              </div>
            </Grid> */}
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <div className="ml-1">
                {["mon", "tue", "wed", "thu", "fri", "sat", "sun"].map(
                  e => (
                    <FormControlLabel
                      style={{ marginLeft: 0 }}
                      disabled={readonly}
                      key={e}
                      control={
                        <Checkbox
                          onChange={(e) => {
                            const v = [...values.loopModeDays]
                            if (e.target.checked) v.push(e.target.name)
                            else v.splice(v.indexOf(e.target.name), 1)
                            handleChange({
                              target: {
                                name: "contentTemplateDetail.loopModeDays",
                                value: v
                              }
                            })
                          }}
                          name={e}
                          checked={values.loopModeDays.indexOf(e) >= 0}
                        />
                      }
                      label={t(`dialog.${e}Text`)}
                    />
                  )
                )}
              </div>
            </Grid>
          </Grid>
        )}
      </div>
    </div>
  )
}

export default LoopMode
